import { AlertTriangle, RefreshCcw } from "lucide-react";

const BackupErrorAlert = ({errorMsg,handleRetry}) => {
  return (
    <div className="mb-4 flex items-center gap-2 rounded-xl border border-[#E4B7AC] bg-[#FBEDE9] px-3.5 py-3 text-sm text-[#7A2E22]">
      <AlertTriangle size={18} className="shrink-0" />
      <span className="flex-1">{errorMsg}</span>
      <button
        type="button"
        onClick={handleRetry}
        className="flex shrink-0 items-center gap-1.5 rounded-lg border border-[#E4B7AC] bg-white px-2.5 py-1.5 text-[12.5px] font-bold text-[#7A2E22] transition-colors hover:bg-[#FBEDE9]"
      >
        <RefreshCcw size={14} />
        تلاش دوباره
      </button>
    </div>
  );
};

export default BackupErrorAlert;
